import { GET_USER_ROLE } from "../ActionTypes";

const initialState = {
  currentUser: {},
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_ROLE:
      return {
        ...state,
        currentUser: action.payload,
      };

    default:
      return state;
  }
};

export default authReducer;
